/**
 * 多语言包加载机制
 * @name language（zh-CN、zh-TW、en-US）
 */
import Url from 'c-url';
import LangUtil from './index';
import $ from 'jquery';

const tws = [
	'zh-SG', 
	'zh-MO', 
	'zh-TW',
	'zh-HK'
];
const ars = [
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE'
];
const getLangFile = (langType, prev = '', defaultLang = 'enus') => {
    return new Promise((resolve, reject) => {
        $.get(langUrl + (prev ? (prev + '/') : '') + langType + '.js?t=' + new Date().getTime()).done((data) => {
            resolve(eval(data))
        }).fail(function() {
            langType !== defaultLang && getLangFile(defaultLang, prev).then(d => resolve(d)).catch(d => reject(d));
        });
    })

}
const loadI18n = function(module, defaultLang) {
    let lang = Url.query('_lang') || Url.query('lang') || window.g_Language;
    if (!lang) {
        let systemLanguage = navigator.language || navigator.browserLanguage;
        let _systemLanguage = systemLanguage.toLowerCase();
        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            default:
                break;
        }
        let arr = systemLanguage.split('-');
        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-US';
        }
        if (tws.indexOf(systemLanguage) >= 0) {
            lang = 'zh-TW';
        } else if (ars.indexOf(systemLanguage) >= 0) {
            lang = 'ar-EG';
        } else {
            lang = systemLanguage;
        }
    }
    let language = lang.replace('-', '').toLowerCase();
    loadI18n.language = language;
    return getLangFile(language, module, defaultLang || 'enus').then(v => {
        LangUtil.init(window.UpliveLangPack);
        return Promise.resolve();
    })
}
export default loadI18n;


// WEBPACK FOOTER //
// ./js/lang/loader.js